module.exports = "images/luna-vector.svg";